import type { ActionExecution } from './runActionWithAsyncFallback';
import type { MailboxType } from 'owa-client-types';
import { MailboxInfoError } from '../MailboxInfoError';
import { logGreyErrorFromAccounts } from 'owa-account-analytics';

export function logMailboxInfoNotFromStore(
    execution: ActionExecution,
    mailboxType: MailboxType
): void {
    const error = new MailboxInfoError('MailboxInfo not from store');
    logGreyErrorFromAccounts('MailboxInfoNotFromStore', error, { execution, mailboxType });
}
